import React from 'react';

import { ButtonField, Step } from '../SteppedForm';
import { Typography, IconButton } from '@material-ui/core';
import { Info as InfoIcon } from '@material-ui/icons';

const StepIntro = (props) => {
  return (
    <Step
      id="intro"
      title={props.vehicleOnboarding ? 'Vehicle Application Form' : 'Operator Application Form'}
      nextText="Get started"
      nonext>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
        {props.vehicleOnboarding ? (
          <div style={{ maxWidth: '800px' }}>
            <Typography style={{ textAlign: 'left' }}>
              Thank you for choosing to be a part of the 13cabs fleet as a Professional Operator!
            </Typography>
            <br />
            <Typography style={{ textAlign: 'left' }}>
              <b>
                Please note: this form should only be used by pre-exsisting operators looking to
                onboard new vehicles. This form should not be used for onboarding a new operator
              </b>
            </Typography>
            <br />
            <div style={{ textAlign: 'left' }}>
              <Typography>
                You will need to have important information ready in order to complete this form.
                Please click{' '}
                <IconButton
                  color="primary"
                  style={{ padding: 0, margin: '0 3px 2px -3px', color: '#1a76d9' }}
                  component="span"
                  onClick={props.openInfo}>
                  <InfoIcon />
                </IconButton>
                for a list of required documentation
              </Typography>
              <br />
              <Typography>
                If you need to pause this application at any time, it will be automatically saved on
                your device. You can return and complete the application at a later time.
              </Typography>
              <br />
            </div>
          </div>
        ) : (
          <div style={{ maxWidth: '800px' }}>
            <Typography style={{ textAlign: 'left' }}>
              Thank you for choosing to be a part of the 13cabs fleet as a Professional Operator!
            </Typography>
            <br />
            <div style={{ textAlign: 'left' }}>
              <Typography>
                You will need to have important information ready in order to complete this form.
                Please click{' '}
                <IconButton
                  color="primary"
                  style={{ padding: 0, margin: '0 3px 2px -3px', color: '#1a76d9' }}
                  component="span"
                  onClick={props.openInfo}>
                  <InfoIcon />
                </IconButton>
                for a list of required documentation
              </Typography>
              <br />
              <Typography>
                Select your state for a helpful list of Frequently Asked Questions before you start
                the application
              </Typography>
              <br />
              <Typography>
                If you need to pause this application at any time, it will be automatically saved on
                your device. You can return and complete the application at a later time.
              </Typography>
              <br />
            </div>
          </div>
        )}
      </div>
      <h4>Select the state that your Taxi will operate in.</h4>
      <br />
      {Object.keys(props.config.states).map((state) => (
        <ButtonField
          id="state"
          key={state}
          value={state}
          label={props.config.states[state].label}
        />
      ))}
      {props.infoContent()}
    </Step>
  );
};

export default StepIntro;
